export default __webpack_public_path__ + "static/media/phone.3dcfcbd0.svg";